import { peopleTypes } from '@/reports/index';
import {
  ContactTeaserData,
  SerializedContactTeaserData,
} from '@/search/useSearchContact/Interfaces';
import {
  formatCompany,
  formatJob,
  formatLocation,
  titleize,
} from '@/utils/index';
import { lookupStateName } from '@/utils/states';

/**
 * Serializes a contact teaser response object
 * @param rawData A contact teaser response object
 * @returns A serialized contact teaser response object
 */
export function SerializedContactTeaser(
  rawData: ContactTeaserData
): SerializedContactTeaserData {
  return {
    contacts: rawData.entities.people.map((person: peopleTypes.FullPerson) => {
      const parsedAddress = person.contact?.addresses[0]?.parsed;

      return {
        id: person.identity.source_ids[0],
        name: titleize(person.identity.names[0]?.full || ''),
        title: formatJob(person.jobs[0]?.additional_titles[0]?.name || ''),
        companies: person.jobs.map((job) => ({
          name: formatCompany(job.company || ''),
          website: job.company_profile?.website || '',
          isBest: job.meta?.is_best || false,
        })),
        address: parsedAddress
          ? formatLocation(
              titleize(parsedAddress.city || ''),
              lookupStateName(parsedAddress.state)
            )
          : '',
        usernames: person.social.usernames
          .map((username) => username.username)
          .filter((username): username is string => username !== null),
      };
    }),
    total: rawData.meta.available?.people ?? 0,
  };
}
